export const sectionConfig = {
  app_service: {
    color: "sky",
    pre: "اپلیکیشن",
    title: "فیگ ای آی",
    caption: "دسترسی نامحدود به دنیای هوش مصنوعی در یک پلتفرم بومی و قدرتمند.",
    uni_line_price: "همین حالا مدل‌ها را بررسی کنید",
    start_button: {
      label: "مشاهده مدل‌ها",
      link: "/models",
    },
    features: [
      {
        title: "دسترسی یکپارچه",
        caption: "تجربه کار با پیشرفته‌ترین مدل‌های جهان در یک محیط واحد.",
        icon: "chart",
      },
      {
        title: "سیستم اعتباری منعطف",
        caption:
          "بدون محدودیت زمانی یا ماهانه؛ اعتبار شما تا زمان مصرف، بدون تاریخ انقضا باقی می‌ماند.",
        icon: "check",
      },
      {
        title: "رابط کاربری بهینه",
        caption:
          "طراحی ساده و سرعت بالا، دقیقاً مشابه تجربه کاربری پلتفرم‌های تراز اول دنیا.",
        icon: "headphones",
      },
      {
        title: "شخصی‌سازی گسترده",
        caption:
          "از تغییر ظاهر و تم گرفته تا تنظیمات پیشرفته مدل‌ها؛ همه‌چیز طبق سلیقه شماست.",
        icon: "star",
      },
    ],
  },
  pro_service: {
    color: "purple",
    pre: "اشتراک",
    title: "اولترا",
    caption:
      "پکیج حرفه‌ای برای کسانی که به دنبال قدرت حداکثری و عملکرد بدون توقف هستند.",
    uni_line_price: "مشاهده تعرفه‌ها در صفحه پرداخت",
    start_button: {
      label: "تهیه اشتراک",
      link: "https://pay.figai.ir/",
      term: "landing_ultra_plan",
      ref: true,
    },
    features: [
      {
        title: "قدرت پردازش فوق‌العاده",
        caption: "دسترسی به پرچمدارترین مدل‌های هوش مصنوعی دنیا.",
        icon: "thunder",
      },
      {
        title: "پشتیبانی اختصاصی",
        caption:
          "تیم فنی و فروش ما در سریع‌ترین زمان ممکن در کنار شما خواهند بود.",
        icon: "tick",
      },
      {
        title: "ظرفیت بالای توکن",
        caption:
          "ارائه سقف توکن بالا، ایده‌آل برای برنامه‌نویسی حرفه‌ای و تحلیل‌ فایل‌های حجیم.",
        icon: "analysis",
      },
      {
        title: "شفافیت هزینه‌ها",
        caption:
          "نمایش دقیق و لحظه‌ای هزینه کسر شده از اعتبار بر اساس میزان مصرف توکن.",
        icon: "guard",
      },
    ],
  },
  org_service: {
    color: "green",
    pre: "پلن",
    title: "سازمانی",
    caption:
      "راهکار جامع برای هوشمندسازی کسب‌وکار و مدیریت متمرکز تیم‌های بزرگ.",
    uni_line_price: "قیمت: تماس با واحد فروش",
    start_button: {
      label: "اطلاعات بیشتر",
      link: "/contact-us",
    },
    features: [
      {
        title: "پنل اختصاصی Open WebUI",
        caption:
          "محیط کاربری پیشرفته و اختصاصی با قابلیت شخصی‌سازی کامل برای سازمان‌ها.",
        icon: "thunder",
      },
      {
        title: "مدیریت متمرکز تیم‌ها",
        caption:
          "تعریف دسترسی‌ها، محدودسازی مدل‌ها و نظارت دقیق بر مصرف اعضای تیم.",
        icon: "guard",
      },
      {
        title: "گزارش‌گیری پیشرفته",
        caption:
          "آنالیز دقیق داده‌های مصرفی جهت تصمیم‌گیری‌های استراتژیک و مدیریتی.",
        icon: "analysis",
      },
      {
        title: "پشتیبانی ویژه (SLA)",
        caption:
          "مشاوره تخصصی و پشتیبانی فنی برای پیاده‌سازی زیرساخت‌های پیچیده.",
        icon: "tick",
      },
    ],
  },
};

export type SectionConfig = typeof sectionConfig;
